import { useState } from 'react'
import {
  CloseOutlined,
  DoubleRightOutlined,
  DownOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { minimizeLogoImage } from '@pig-common/constants/images'
import { Divider, Image } from '@pig-frontend/uikit'
import { Popover, Space, Modal } from 'antd'
import ChatRoomList, {
  roomIndex,
} from '@pig-common/components/Chat/ChatRoomList'
import { useRecoilState, useRecoilValue } from 'recoil'
import { chatChannelStateCommon } from '@pig-common/recoils'
import { useMediaQuery } from '@pig-frontend/uikit'
import styles from './index.module.scss'

export default function ChatHeader() {
  const isMD = useMediaQuery('md')
  const [modalVisible, setModalVisible] = useState<boolean>(false)
  const [showPopover, setShowPopover] = useState<boolean>(false)
  const [isChatVisible, setChatVisible] = useRecoilState(
    chatChannelStateCommon.chatPanelVisibleState,
  )
  const { currentChannel } = useRecoilValue(
    chatChannelStateCommon.chatChannelState,
  )

  if (!isChatVisible) {
    return null
  }

  const handleChatLabel = () => {
    const room = roomIndex.find((channel) =>
      currentChannel?.includes(channel.id),
    )
    if (room) {
      return room.name
    } else {
      return 'ทุกคน'
    }
  }

  const linkLine = () => {
    window.location.assign(`${window.location.origin}/line`)
  }

  return (
    <>
      <Modal
        footer={null}
        open={modalVisible}
        getContainer={false}
        closable={false}
        onCancel={() => setModalVisible(false)}
      >
        <div className={styles['tac-modal']}>
          <div className={styles.header}>
            <h5 className={styles.title}>ระเบียบและข้อกำหนด</h5>
            <CloseOutlined
              className={styles['close-icon']}
              role="button"
              onClick={() => setModalVisible(false)}
            />
          </div>
          <Divider />
          <ol className="p-3">
            <li>
              งดใช้ถ้อยคำที่หยาบคาย ดูหมิ่น หลอกลวงหรือก่อให้เกิด
              ความเสียหายแก่ผู้เล่นท่านอื่น
            </li>
            <li>งดการโฆษณาผลิตภัณฑ์ รวมถึงการใส่ลิงก์เว็บไซต์อื่นๆ</li>
            <li>
              งดการส่งข้อความที่ถี่จนเกินไป ซึ่งอาจทำลายบรรยากาศ
              และความเรียบร้อยภายในห้องแชท
            </li>
            <li>
              ห้องแชทนี้มีไว้สำหรับพูดคุยแลกเปลี่ยนกับผู้เล่นท่านอื่น
              หากมีปัญหาในการใช้งานเว็บไซต์ ผู้เล่นสามารถ
              <div
                className={styles.link}
                onClick={linkLine}
                onKeyDown={linkLine}
              >
                ติดต่อแอดมินได้ที่นี่
              </div>
            </li>
          </ol>
        </div>
      </Modal>

      <div className={styles.container}>
        <div className={styles['header-group']}>
          {isMD ? (
            <DoubleRightOutlined
              className={styles['back-icon']}
              onClick={() => setChatVisible(false)}
            />
          ) : (
            <>
              <LeftOutlined
                className={styles['back-icon']}
                role="button"
                onClick={() => setChatVisible(false)}
              />
              <Image
                className={styles.logo}
                src={minimizeLogoImage}
                height={45}
                width={45}
                alt="pigbet logo"
              />
            </>
          )}
        </div>
        <div className={styles['header-group']}>
          <InfoCircleOutlined
            className={styles['info-icon']}
            onClick={() => {
              setModalVisible(true)
            }}
            role="button"
          />
          <Popover
            overlayClassName="ps-chatroom-selector"
            content={<ChatRoomList onSelected={() => setShowPopover(false)} />}
            trigger={['click']}
            placement="bottomRight"
            getPopupContainer={(triggerNode) => triggerNode}
            open={showPopover}
            onOpenChange={() => setShowPopover(!showPopover)}
          >
            <Space className={styles['selected-text-wrapper']}>
              <span className={styles['selected-text']}>
                {handleChatLabel()}
              </span>
              <DownOutlined className={styles['down-icon']} />
            </Space>
          </Popover>
          <UnorderedListOutlined className={styles['member-icon']} />
        </div>
      </div>
    </>
  )
}
